import { initializeApp } from "firebase/app";
import { getAnalytics, initializeAnalytics, setAnalyticsCollectionEnabled, setUserProperties } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
import { getStoredAnalyticsUserData, resolveAnalyticsUserType, shouldCollectAnalytics } from './analytics-collection.util';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE__MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Disable auto page_view so only manual logEvent calls fire
initializeAnalytics(app, { config: { send_page_view: false } });

const firebase = () => {
  const { email: userEmail, country, location } = getStoredAnalyticsUserData();
  const userCountry = country || location;

  const analytics = getAnalytics(app);
  const perf = getPerformance(app);
  const collectAnalytics = shouldCollectAnalytics();

  setAnalyticsCollectionEnabled(analytics, collectAnalytics);

  if (!collectAnalytics) {
    return {
      analytics,
      perf,
    };
  }

  const appUserType = resolveAnalyticsUserType(userEmail);
  const appUserCountry = userCountry || process.env.REACT_APP_DEFAULT_COUNTRY || 'unknown';

  setUserProperties(analytics, {
    app_user_type: appUserType,
    app_user_country: appUserCountry,
  });

  return {
    analytics,
    perf,
  };
};
export default firebase;
